import { render, staticRenderFns } from "./IconSvgMonitor.vue?vue&type=template&id=b5c9134e&scoped=true&"
import script from "./IconSvgMonitor.vue?vue&type=script&lang=js&"
export * from "./IconSvgMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c9134e",
  null
  
)

export default component.exports